import {AppType, appType} from "../global/appInfo.js";
import type {FunctionImplementation} from "@otto-ec/global-resources/nexus";
import {sharing, type Sharing} from "./index.js";

export interface NativeShareOptions {
    /**
 *
 */
    url: string;
    /**
 *
 */
    type: string;
}

export const shareNative = function shareNative(data) {
    if (appType() !== AppType.ANDROID) {
        throw new Error(
            "sharing.shareNative is only supported in the Android app. " +
            "On iOS and in browsers use the Web Share API (navigator.share) directly."
        );
    }
    window.o_apps_android?.shareNative?.(data.url, data.type)
} satisfies FunctionImplementation<Sharing["shareNative"]>

sharing.assignNamespace({shareNative})
